import { openAPIConnectionsCommand } from './open_api_connections';

export const apiConnectionCommands = [
  openAPIConnectionsCommand
];
